import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/Asset 11.png';
import small_logo from '../../assets/android-chrome-512x512.png';
import { MdOutlineSpaceDashboard } from "react-icons/md"; 
import { MdKeyboardArrowRight } from "react-icons/md";
import { IoBookmarksOutline } from "react-icons/io5"; 
import { FiUser, FiUsers } from 'react-icons/fi';
import { BiHomeAlt } from 'react-icons/bi';
import _constantUtil from '../../utils/Constant';
import { GoTable, GoTrophy } from 'react-icons/go';

function Sidebar({ isSidebarVisible }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenuId, setOpenMenuId] = useState('');

  const menuItems = [
    {
      id: 'dashboards',
      tab: 'dashboard',
      iconClass: <BiHomeAlt />,
      text: 'Dashboard',
      link: '/dashboard',
    },
    {
      id: 'sports',
      tab: 'sports',
      iconClass: <MdOutlineSpaceDashboard />,
      text: 'Sports',
      submenuItems: [
        { text: 'All Sports', link: '/sports/all-sports', tab: '/sports' },
      ],
    },
    {
      id: 'user-manager',
      tab: 'user',
      iconClass: <FiUser />,
      text: 'User Manager',
      submenuItems: [
        { text: 'All User', link: '/user/all-user', tab: '/user' },
      ],
    },
    {
      id: 'tournament',
      tab: 'tournament',
      iconClass: <GoTable />,
      text: 'Tournament',
      submenuItems: [
        { text: 'All Tournament', link: '/tournament/all-tournament', tab: '/tournament' },
      ],
    },
    {
      id: 'team-manager',
      tab: 'team',
      iconClass: <FiUsers />,
      text: 'Team Manager',
      submenuItems: [
        { text: 'All Team', link: '/team/all-team', tab: '/team' },
      ],
    }, 
    {
      id: 'match-manager',
      tab: 'match',
      iconClass: <IoBookmarksOutline />,
      text: 'Match Manager',
      submenuItems: [
        { text: 'Upcoming Match', link: '/match/all-upcoming', tab: '/match' },
        { text: 'Launched Match', link: '/match/all-launch', tab: '/match' },
        { text: 'Live Match', link: '/match/all-live', tab: '/match' },
        { text: 'Completed Match', link: '/match/all-completed', tab: '/match' },
        { text: 'Abandoned Match', link: '/match/all-abandoned', tab: '/match' },
      ],
    },
    {
      id: 'question-manager',
      tab: 'question',
      iconClass: <GoTrophy />,
      text: 'Question Manager',
      submenuItems: [
        { text: 'All Category', link: '/question/question-category', tab: '/question' },
        { text: 'Global Question', link: '/question/global-question', tab: '/question' },
      ],
    },
    {
      id: 'deposit-manager',
      tab: 'deposit',
      iconClass: <FiUsers />,
      text: 'Deposit Manager',
      submenuItems: [
        { text: 'All Deposit', link: '/deposit/all-deposit', tab: '/deposit' }, 
      ],
    },
  ];
  
  useEffect(() => {
    const activeMenu = menuItems.find(item => {
      return item.submenuItems 
        ? location.pathname.includes(item.submenuItems[0].tab) 
        : location.pathname === item.link;  
    });
    
    setOpenMenuId(activeMenu ? activeMenu.id : '');
  }, [location.pathname]);

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? _constantUtil.NULL : id);
  };

  const handleLinkClick = (link) => {
    navigate(link, { replace: _constantUtil.BOOLEAN_TRUE });
  };

  return (
    <div className={`main-menu ${isSidebarVisible ? 'sidebar-enable' : ''}`}>
      <div className='logo-box justify-content-center'>
        <div className='logo-light'>
          <img src={logo} alt='logo' className='logo-lg' height={50} style={{cursor:'pointer'}} onClick={() => navigate('/dashboard')} />
          <img src={small_logo} alt='small logo' className='logo-sm' height={45} style={{cursor:'pointer'}} onClick={() => navigate('/dashboard')} />
        </div>
        <div className='logo-dark'>
          <img src={logo} alt='dark logo' className='logo-lg' height={60} style={{cursor:'pointer'}} onClick={() => navigate('/dashboard')} />
          <img src={small_logo} alt='small logo' className='logo-sm' height={45} style={{cursor:'pointer'}} onClick={() => navigate('/dashboard')} />
        </div>
      </div>

      <div data-simplebar style={{borderTop: '1px solid #e9edf3'}}>
        <ul className='app-menu list-unstyled mt-2'> 
          {menuItems.map((menuItem) => (
            <li key={menuItem.id} className='menu-item'> 
              {menuItem.submenuItems ? (
                <>
                  <a
                    onClick={() => toggleMenu(menuItem.id)}
                    className='menu-link waves-effect waves-light'
                    aria-expanded={openMenuId === menuItem.id ? 'true' : 'false'}
                  >
                    <span className='menu-icon'>{menuItem.iconClass}</span>
                    <span className='menu-text'>{menuItem.text}</span>
                    <MdKeyboardArrowRight className='menu-arrow' />
                  </a>
                  <div className={`collapse ${openMenuId === menuItem.id ? 'show' : ''}`} id={`menu-${menuItem.id}`}>
                    <ul className='sub-menu'>
                      {menuItem.submenuItems.map((submenuItem, index) => (
                        <li key={index} className={`menu-item ${location.pathname === submenuItem.link ? 'active' : ''}`}>
                          <a
                            onClick={() => handleLinkClick(submenuItem.link)}
                            className='menu-link'
                            style={{ background: 'none' }}
                          >
                            <span className='menu-text' style={{ background: 'none', cursor: 'pointer' }}>{submenuItem.text}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              ) : (
                <a
                  onClick={() => handleLinkClick(menuItem.link)}  
                  className={`menu-link waves-effect waves-light ${location.pathname === menuItem.link ? 'sidebar-active' : ''}`}
                >
                  <span className='menu-icon'>{menuItem.iconClass}</span>
                  <span className='menu-text' style={{cursor:'pointer'}}>{menuItem.text}</span>
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
